A question component of an `ApplicationQuestionnaire`.

This consists of label text displayed to a user and an input for them to select a response.
